<template>
    <!-- 防止app_aside先resources.js ，此时的router还没有初始化-->
    <div id="app" style="overflow: hidden;height: 100%;">
        <app-head></app-head>
        <app-aside :class="hideOrshow" :currentNodeName="tab_cur_name" @toggleMenu="toggleMenu" @passLinkVal="getLinkVal" @showJump="showJump" ref="appAside" @showAd="showAd" @showEnvironment="showEnvironment"></app-aside>
        <div  class="app-content" :class="{ active: tab_cur_name != -1 }">
            <div class="tab">
                <div class="tab-head">
                    <el-tabs id="head-tabs" v-model="tab_cur_name" @tab-click="tab_click" type="card" @tab-remove="tab_remove" @contextmenu.native="contextmenu">
                        <el-tab-pane label="首页" name="-1"></el-tab-pane>
                        <el-tab-pane label="待办事项" name="-2" class="name_1"></el-tab-pane>
                        <el-tab-pane v-for="temp in tab_list" :label="temp.label" :name="temp.name" :key="temp.name" closable></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="mainRouterView">
                    <router-view ref="routeComp" :hide_menu="hide_menu"></router-view>
                </div>
            </div>
            <div @click="toggleMenu" class="toggle-menu"  title="隐藏侧边栏">
                <div class="toggle-menu-btn" >
                    <i class="el-icon-arrow-left" style="margin-left: -2px" v-show="!hide_menu"></i>
                    <i class="el-icon-arrow-right" style="margin-left: -2px" v-show="hide_menu"></i>
                </div>
            </div>
        </div>
        <!-- </div> -->
        <footer style="float:right;font-size:14px;">
            <a href="http://www.hymake.com" target="new" style="font-size:14px;color:#41464a;">@厦门海迈科技股份有限公司</a>
            <!-- <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302032944" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                 <img :src="ghs" style="float:left;margin-top: 5px"/>
                 <span style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#FFFFFF;margin-top: 5px">闽公网安备 35020302032944号</span>
             </a>-->
        </footer>

        <el-menu class="el-menu-context" :style="{top:clientY  ,  left:clientX , width:'150px' , display: (showContextmenu?'block':'none') }">
            <el-menu-item index="1">
                <div slot="title" @click="closeCur()">关闭当前</div>
            </el-menu-item>
            <el-menu-item index="2">
                <div slot="title" @click="closeOth()">关闭其他</div>
            </el-menu-item>
            <el-menu-item index="4">
                <div slot="title" @click="closeRight()">关闭到右侧</div>
            </el-menu-item>
            <el-menu-item index="5">
                <div slot="title" @click="closeLeft()">关闭到左侧</div>
            </el-menu-item>
            <el-menu-item index="3">
                <div slot="title" @click="closeAll()">关闭所有</div>
            </el-menu-item>
        </el-menu>
        <div class="back" v-if="imgShow" >
            <img :src="this.img" alt="造价神器了解一下">
            <a href="http://zaojia.hymake.cn"target="_blank"></a>
            <div class="del" @click="imgShow = false"></div>
        </div>
        <div class="dialog" v-if="showDialog">
            <div class="cont cont1">
                <img :src="del" class="img" alt="关闭" @click="showDialog = false" style="z-index: 10">
                <div style="overflow: hidden;height: 510px;text-align: center;position: relative">
                    <img :src="file" style="cursor: pointer" @click="showDialogBid = true">
                </div>
            </div>
        </div>
        <!--<div class="dialog" v-if="showDialogBid">
            <div style="text-align: center;" class="cont cont2">
                <img :src="del" class="img" alt="关闭" @click="showDialogBid = false" style="z-index: 10">
                <div style="text-align: center;position: relative">
                    <img :src="efile">
                    &lt;!&ndash; <img :src="ke" alt="电子档案平台" style="position: absolute;bottom:0px;right: 110px;width: 18%">&ndash;&gt;
                </div>
            </div>
        </div>-->
        <div class="dialog" v-if="showAdDialog">
            <div style="text-align: center;" class="cont">
                <img :src="del" class="img" alt="关闭" @click="showAdDialog = false">
                <p style="color: #1cf62f;font-size: 24px;font-weight: bold">信用加分了解一下？</p>
                <p style="color: #396eff;font-size: 20px;">使用海迈电子档案平台，就有信用加分啦~~欢迎马上加入第四批省站试点项目名单。</p>
                <p style="text-align: right;color: red">加分热线：181 5929 5756 罗工&emsp;<br>  0592-5399945 龚工&emsp;</p>
                <p style="line-height: 30px;text-align: left;margin: 0 20px;border: 1px solid #666;padding: 5px">相关政策文件：<br>关于再次征求《建筑施工企业通常行为评价标准（2018年版第二次征求意见稿）》意见的通知 <b style="color: red;font-size: 14px">[闽建办筑函〔2018〕28号]</b>
                    <br>4.5项目电子档案管理 <br>按照工程类别（房建总承包、市政总承包），分别在房建总承包、市政总承包两类序列中加分。（满分1分）</p>
                <div style="margin: 5px 20px;text-align: left">
                    <img :src="luo" style="text-align: left;" title="扫一扫了解详细政策及软件介绍" width="100px">&ensp;<span style="font-size: 18px;color: #333">扫一扫了解详细政策及软件介绍（请备注单位名称及姓名）</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { bus } from "./bus.js"
    import appHead from "./components/common/app_head.vue";
    import appAside from "./components/common/app_aside.vue";
    import dialog from "./static/images/dialog.png";
    import ghs from "./static/images/ghs.png";
    import del from "./static/images/del.png";
    import luo from "./static/images/luo.png";
    import file from "./static/images/Ad/file.png";
    export default {
        name: 'app',
        created() {
            this.$nextTick(function() {
                if( this.$route.path == "/" ){
                    this.$router.replace("/home");
                }
                if (this.$route.path != "/home"){
                    // console.log("index")
                    this.$router.replace("/index");
                }
            })

        },
        mounted() {
            // 右击el-tab显示相应的内容
            let me = this;
            $(document).on('click', function() {
                me.showContextmenu = false;
            })
            $(document).on('contextmenu', '#head-tabs .el-tabs__item', function(e) {
                return false;
            })
            $(document).on('contextmenu', '#head-tabs .el-tabs__item.is-active', function(e) {
                this.type = 0;
                me.clientX = e.clientX + "px";
                me.clientY = e.clientY + "px";
                me.showContextmenu = true; //--全局
            })
            $(document).on('click', '.el-menu-context>.el-menu-item', function(e) {
                $(e.target).parent().removeClass("is-active")
            })
            /*setTimeout(() => {
                this.imgShow = false;
            }, 5000)*/
            if (process.env.NODE_ENV === 'production') {
                this.showAdDialog = false;
            }else{
                this.showAdDialog = false;
            }
        },
        data() {
            return {
                hide_menu: false,
                tab_list: [], //{ label:"标签名字" , name :"menuCode" , href:"路由" , index: 上一个的index+1}
                tab_cur_name: "-1",
                tabIndex: -1, //tab_list.index
                keep_alive_list: [], //标签页的组件name(=menuCode，用作缓存
                clientX: "",
                clientY: "",
                showContextmenu: false,
                img:dialog,
                del:del,
                ghs:ghs,
                luo:luo,
                file:file,
                imgShow:false,
                showDialog:false,
                showAdDialog:false,
                showDialogBid:false,
                tab_cur_index:{name:"",index:1},
                type:0,
            };
        },
        methods: {
            closeCur() {
                // 关闭当前页签
                if(this.type == 0){
                    this.tab_remove(this.tab_cur_name);
                }else{
                    this.tab_remove(this.tab_cur_index.name);
                }
            },
            closeOth() {
                // 关闭其他
                let tabs = this.tab_list;
                let activeName = this.tab_cur_name;
                if(this.type == 1){
                    this.tab_click(0);
                    this.tab_cur_name = this.tab_cur_index.name;
                    activeName = this.tab_cur_name;
                }
                this.tab_list = tabs.filter(tab => tab.name == activeName);
            },
            closeAll(type) {
                this.tab_cur_name = "-1";
                this.tab_list = [];
                this.$router.replace("/index");
            },
            closeRight(type) {
                // 关闭到右侧
                let tabs = this.tab_list;
                let tabIndex = this.tabIndex;
                if(this.type == 1){
                    this.tab_click(0);
                    this.tab_cur_name = this.tab_cur_index.name;
                    tabIndex = this.tab_cur_index.index;
                }
                this.tab_list = tabs.filter(tab => tab.index <= tabIndex);
            },
            closeLeft(type) {
                // 关闭到左侧
                let tabs = this.tab_list;
                let tabIndex = this.tabIndex;
                if(this.type == 1){
                    this.tab_click(0);
                    this.tab_cur_name = this.tab_cur_index.name;
                    tabIndex = this.tab_cur_index.index;
                }
                this.tab_list = tabs.filter(tab => tab.index >= tabIndex);
            },
            getLinkVal: function(val) {
                //console.log(val)
                //用户点击左侧树连接
                let i = 0;
                let a = this.tab_list;
                let linkName = val[0]["linkName"],
                    menuCode = val[0]["menuCode"],
                    href = val[0]["href"];

                //左侧树的连接已在页签中存在
                for (i, a; i < a.length; i++) {
                    if (linkName === a[i].label) {
                        this.tab_cur_name = a[i].name;
                        this.tabIndex = a[i].index;
                        break;
                    }
                }
                //新页签
                if (i == a.length) {
                    let preIndex = this.tab_list[a.length - 1] ? this.tab_list[a.length - 1].index : 0;
                    this.tab_cur_name = menuCode;
                    this.tab_list.push({ label: linkName, name: menuCode, href: href, index: preIndex + 1 });
                    this.tabIndex = preIndex + 1;
                }
            },
            //点击标签路由跳转
            tab_click: function(tab) {
                let tabs = this.tab_list;
                let click_tab;
                if(tab == 0){
                    click_tab = this.tab_cur_index;
                }else{
                    click_tab = tab.$options.propsData;
                }
                if (click_tab.name === "-1") {//首页
                    this.tabIndex = 0;
                    this.$router.replace("/index");
                } else if (click_tab.name === "-2") {//待办事项
                    this.tabIndex = 0;
                    this.$router.replace("/tobedone");
                } else {
                    tabs.forEach((tab, index) => {
                        if (tab.name == click_tab.name) {
                            this.tabIndex = tab.index;
                            this.$router.replace(tab.href);
                        }
                    });
                }
            },
            tab_remove: function(targetName) {
                let tabs = this.tab_list;
                let activeName = this.tab_cur_name;
                let me = this;
                let href = "";
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                activeName = nextTab.name;
                                href = nextTab.href;
                                me.keep_alive_list.forEach((item, index) => {
                                    if (item === tab.name) {
                                        me.keep_alive_list.splice(index, 1);
                                        return false;
                                    }
                                });
                            } else {
                                activeName = "-1";
                                href = "/index";
                                me.keep_alive_list = [];
                            }
                        }
                    });
                }
                this.tab_cur_name = activeName;
                this.tab_list = tabs.filter(tab => tab.name !== targetName);
                this.$router.replace(href);
            },
            toggleMenu: function() {
                this.hide_menu = !this.hide_menu;
            },
            showJump:function (str) {
                this.getLinkVal(str);
                this.$router.replace(str[0].href);
                this.$refs.appAside.showTarge();
            },
            showAd(){
                this.showAdDialog = true;
            },
            showEnvironment(){
                let data = [{linkName: "海迈环境监测系统", menuCode: "environmentDetection", href: "/video/environmentDetection"}];
                this.getLinkVal(data);
                this.$router.replace("/video/environmentDetection");
            },
            contextmenu(e){
                if(!$(e.target).hasClass("is-active") && !$(e.target).hasClass("el-tabs__nav-scroll")){
                    this.type = 1;
                    let index = $(".el-tabs__item").index($(e.target));
                    if(index == 0){
                        this.tab_cur_index = { label: "首页", name: "-1",index:0};
                    }else if(index == 1){
                        this.tab_cur_index = { label: "待办事项", name: "-2",index:0};
                    }else{
                        this.tab_cur_index = this.tab_list[index-2];
                        this.tab_cur_index.index = index - 1;
                    }
                    this.clientX = e.clientX + "px";
                    this.clientY = e.clientY + "px";
                    this.showContextmenu = true;
                }else{
                    this.type = 0;
                }
            },
        },
        beforeRouteLeave (to, from, next) {
            if(to.path == "/jump"){
                let data = [{linkName: "项目查看", menuCode: "project", href: "/materials/project"}];
                this.getLinkVal(data);
                this.$router.replace("/materials/project");
            }else{
                next()
            }
        },
        computed: {
            hideOrshow: function() {
                return { "hide-menu": this.hide_menu, "show-menu": !this.hide_menu };
            }
        },
        components: { appHead, appAside },

    };
</script>

<style>
    .ocxSealDialog,
    .ocxSealDialog .el-dialog--full{
        width:100%;
        height:100%;
    }
    .el-notification{
        box-shadow: 0 2px 4px #50bfff, 0 0 6px #50bfff;
    }
    .el-menu-context {
        background-color: #fff!important;
        position: absolute!important;
        z-index: 10000;
        width: 150px;
        border:1px solid #3589f0;
        box-shadow: 0px 2px 19.6px 0.4px rgba(35, 122, 228,0.1);
        border-radius: 4px!important;
    }

    .el-menu-context>.el-menu-item {
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #333;
        border-radius: 4px!important;
    }
    .el-menu-context>.el-menu-item:hover{
        color: #237ae4;
        background-color: #edf4ff;
    }
    .el-tabs__nav-next, .el-tabs__nav-prev{
        line-height: 54px!important;
    }
    .el-tabs__nav-next:hover, .el-tabs__nav-prev:hover{
        color: #3589f0;
    }
    .mainRouterView{
        width: 100%;position: absolute;top: 0;padding-top: 54px;overflow-y: auto;
    }
    .mainRouterView>div {
        overflow-y: auto !important;
    }

    .el-dialog {
        margin-bottom: 0;
        overflow: hidden;
    }

    .el-dialog__header {
        cursor: move;
    }

    .el-dialog__header {
        height: 50px;
        position: absolute;
        width: 100%;
        top: 0;
    }

    .el-dialog__body {
        position: absolute;
        width: 100%;
        overflow: auto;
        top: 50px;
        bottom: 50px;
        padding: 0 10px 10px !important;
    }

    .el-dialog__footer {
        height: 60px;
        position: absolute;
        width: 100%;
        bottom: 0;
    }

    .el-table {
        font-size: 12px;
    }

    .tab .el-tabs__header {
        margin: 0 5px 0 15px;
        border-bottom: none;
    }

    .tab .el-tabs__item {
        height: 54px;
        line-height: 54px;
        color: #666666;
        font-size: 16px;
        font-family: 微软雅黑;
        padding: 0px;
        margin: 0 16px;
    }
    .el-menu-item.is-active{
        background-color:#97d1ff;
        color: #0265af;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable{
        padding: 0px;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__item:hover {
        color: #3589f0;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__item{
        border:none!important;
    }
    .el-menu--horizontal .el-menu-item {
        font-weight: bold;
    }

    .app-content {
        height: 100%;
        padding-top: 65px;
        padding-bottom: 38px;
        overflow-x: auto;
        position: relative;
        left: 0px;
    }
    .app-content.active{
        padding-left: 10px;
    }
    .app-content>.tab {
        width:100%;
        height: 100%;
        position: relative;
    }
    .app-content .tab-head{
        width:100%;
        position: absolute;
        height: 54px;
        z-index: 3;
        background: #fff;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
        border: none !important;
        background-color: #fff;
        color: #3589f0;
        font-weight: bold;
        position: relative;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active:after{
        content: "";
        display: inline-block;
        width: 100%;
        height: 3px;
        background-color: #3589f0;
        position: absolute;
        bottom: 0px;
        left: 0px;
        z-index: 1;
    }
    center {
        width: 100%;
    }

    footer {
        z-index: 2;
        background-color: #c7ceda;
        width: 100%;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        color: #41464a;
        text-align: center;
        position: absolute;
        bottom: 0;
    }

    .writList td {
        border: 1px solid #aec2cd;
    }
    .maskOCX{
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: white;
        z-index: 7000;
        padding: 20px;
        text-align: center;
    }
    .back{
        position: fixed;
        right:0px;
        bottom: 0px;
        /*background: url(back.png) no-repeat 100% 100%;*/
        width: 25%;
        z-index: 5;
    }
    .back img{
        width: 100%;
    }
    .back .del{
        width: 5%;
        height: 5%;
        position: absolute;
        right: 0px;
        top:0px;
        cursor: pointer;
        z-index: 10;
        background:rgba(0,0,0,0);
    }
    .back a {
        display: block;
        width: 100%;
        position: absolute;
        top: 4%;
        bottom: 0px;
        height: 96%;
        background: rgba(0, 0, 0, 0);
        z-index: 10;
    }
    .dialog{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        top:0px;
        background:rgba(0,0,0,0.5);
        z-index: 10;
        overflow: auto;
    }
    .dialog .cont{
        text-align: center;
        background: #fff;
        width: 910px;
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        padding:20px 10px;
        border:1px solid #333;
        box-shadow: 0px 5px 5px #666;
    }
    .dialog .cont1{
        width: 630px;
        /*margin-left: -315px;
        margin-top: -276px*/
    }
    .dialog .cont2{
        width: 600px;
        margin-left: -300px;
        top:202px;
    }
    .dialog div.cont p{
        font-size: 16px;
        color: #333;
        text-indent: 0;
        letter-spacing:0px;
    }
    .dialog .cont .img{
        width: 25px;
        height: 25px;
        position: absolute;
        top:10px;
        right: 10px;
        cursor: pointer;
    }
    .toggle-menu {
        float: left;
        width: 10px;
        background-color: #3589f0;
        cursor: pointer;
        position: absolute;
        height: 80px;
        top: 40%;
        left: 0px;
        border-radius: 2px;
        z-index: 3;
    }

    .toggle-menu>.toggle-menu-btn {
        color: white;
        background-color: #3589f0;
        height: 30px;
        line-height: 30px;
        position: absolute;
        top: 25px;
    }
    .red{color: red}
</style>



// WEBPACK FOOTER //
// App_son.vue?073034b1